import parametresExploitationApi from '@/api/parametres-exploitation.api'

const getDefaultState = () => {
  return {
    parametresExploitation: {},
    parametresExploitationTypesSol: [],
    parametresExploitationTypesProduction: [],
    parametresExploitationRessourceEffluent: [],
    parametresExploitationStockageCereales: [],
    parametresExploitationAteliersCulture: [],
    isParametresExploitationComplet: false
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    parametresExploitation (state) {
      return state.parametresExploitation
    },
    parametresExploitationTypesSol (state) {
      return state.parametresExploitationTypesSol.filter(p => p.code !== 'INCONNU')
    },
    parametresExploitationTypesProduction (state) {
      return state.parametresExploitationTypesProduction.filter(p => p.code !== 'INCONNU')
    },
    parametresExploitationRessourceEffluent (state) {
      return state.parametresExploitationRessourceEffluent.filter(p => p.code !== 'INCONNU')
    },
    parametresExploitationStockageCereales (state) {
      return state.parametresExploitationStockageCereales.filter(p => p.code !== 'INCONNU')
    },
    parametresExploitationAteliersCulture (state) {
      return state.parametresExploitationAteliersCulture
    },
    isParametresExploitationComplet (state) {
      return state.isParametresExploitationComplet
    }
  },

  mutations: {
    UPDATE_PARAMETRES_EXPLOITATION (state, parametresExploitation) {
      state.parametresExploitation = parametresExploitation
    },
    UPDATE_PARAMETRES_EXPLOITATION_TYPES_SOL (state, parametresExploitationTypesSol) {
      state.parametresExploitationTypesSol = parametresExploitationTypesSol
    },
    UPDATE_PARAMETRES_EXPLOITATION_TYPES_PRODUCTION (state, parametresExploitationTypesProduction) {
      state.parametresExploitationTypesProduction = parametresExploitationTypesProduction
    },
    UPDATE_PARAMETRES_EXPLOITATION_RESSOURCE_EFFLUENT (state, parametresExploitationRessourceEffluent) {
      state.parametresExploitationRessourceEffluent = parametresExploitationRessourceEffluent
    },
    UPDATE_PARAMETRES_EXPLOITATION_STOCKAGE_CEREALES (state, parametresExploitationStockageCereales) {
      state.parametresExploitationStockageCereales = parametresExploitationStockageCereales
    },
    UPDATE_PARAMETRES_EXPLOITATION_ATELIERS_CULTURE (state, parametresExploitationAteliersCulture) {
      state.parametresExploitationAteliersCulture = parametresExploitationAteliersCulture
    },
    UPDATE_IS_PARAMETRES_EXPLOITATION_COMPLET (state, isParametresExploitationComplet) {
      state.isParametresExploitationComplet = isParametresExploitationComplet
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },

  actions: {
    getParametresExploitation ({ commit, rootGetters }) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return parametresExploitationApi.getParametresExploitation(username)
        .then(response => {
          commit('UPDATE_PARAMETRES_EXPLOITATION', response)
        })
    },
    createOrUpdateParametresExploitation ({ dispatch, rootGetters }, parametresExploitation) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      let promiseUpdate
      if (parametresExploitation.id) {
        promiseUpdate = parametresExploitationApi.updateParametresExploitation(username, parametresExploitation)
      } else {
        promiseUpdate = parametresExploitationApi.createParametresExploitation(username, parametresExploitation)
      }
      return promiseUpdate.then(() => dispatch('getParametresExploitation'))
    },
    getParametresExploitationTypesSol ({ commit }) {
      return parametresExploitationApi.getParametresExploitationTypesSol()
        .then(response => {
          commit('UPDATE_PARAMETRES_EXPLOITATION_TYPES_SOL', response)
        })
    },
    getParametresExploitationTypesProduction ({ commit }) {
      return parametresExploitationApi.getParametresExploitationTypesProduction()
        .then(response => {
          commit('UPDATE_PARAMETRES_EXPLOITATION_TYPES_PRODUCTION', response)
        })
    },
    getParametresExploitationRessourceEffluent ({ commit }) {
      return parametresExploitationApi.getParametresExploitationRessourceEffluent()
        .then(response => {
          commit('UPDATE_PARAMETRES_EXPLOITATION_RESSOURCE_EFFLUENT', response)
        })
    },
    getParametresExploitationStockageCereales ({ commit }) {
      return parametresExploitationApi.getParametresExploitationStockageCereales()
        .then(response => {
          commit('UPDATE_PARAMETRES_EXPLOITATION_STOCKAGE_CEREALES', response)
        })
    },
    getParametresExploitationAteliersCulture ({ commit }) {
      return parametresExploitationApi.getParametresExploitationAteliersCulture()
        .then(response => {
          commit('UPDATE_PARAMETRES_EXPLOITATION_ATELIERS_CULTURE', response)
        })
    },
    getParametresExploitationComplet ({ commit, rootGetters }) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return parametresExploitationApi.getParametresExploitationComplet(username)
        .then(response => {
          commit('UPDATE_IS_PARAMETRES_EXPLOITATION_COMPLET', response)
        })
    },
    getParametresExploitationPotentielSol ({ rootGetters }, parametresExploitation) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return parametresExploitationApi.getParametresExploitationPotentielSol(username, parametresExploitation)
    },
    getProfondeurSolParDefaut (ignored, codeTypeSol) {
      return parametresExploitationApi.getProfondeurSolParDefaut(codeTypeSol)
    },
  }
}

export default module
